import { Flex, Image, Text } from "@chakra-ui/react";
import logoIcon from "../../assets/aimon/banner-main.png";
import styles from "./Footer.module.scss";
import {
  companyLinks,
  navigationLinks,
  newsLinks,
  supportLinks,
} from "./config";
import twitterIcon from "../../assets/aimon/twitter-yellow.png";
import discordIcon from "../../assets/aimon/dc-yellow.png";
import telegramIcon from "../../assets/aimon/tg-yellow.png";
import { HashLink as Link } from "react-router-hash-link";

export default function Footer() {
  const isMobile = window.innerWidth < 768;
  const list1 = [...navigationLinks, ...companyLinks];
  const list2 = [...supportLinks, ...newsLinks];
  if (isMobile) {
    return (
      <Flex
        bgColor={"black"}
        zIndex={"1"}
        flexDir={"column"}
        gap={"40px"}
        width={"100%"}
        padding={"40px 20px"}
      >
        <Image className={styles.icon} src={logoIcon} alt="logo" />
        <Flex justifyContent={"space-between"} pl={"10px"}>
          <TxtLinkGroup links={list1} />
          <TxtLinkGroup links={list2} />
        </Flex>
        <Flex gap={"10px"}>
          <Image
            src={telegramIcon}
            alt="logoTg"
            margin={"10px"}
            width={"35px"}
          />
          <Image
            src={discordIcon}
            alt="logoDiscord"
            margin={"10px"}
            width={"35px"}
          />
          <Image src={twitterIcon} alt="logoX" margin={"10px"} width={"35px"} />
        </Flex>
        <Text color={"#FFFFFF80"} fontSize={"12px"}>
          Copyright © 2012- 2025 The AIMON All Rights Reserved
        </Text>
      </Flex>
    );
  }
  return (
    <Flex className={styles.container}>
      <Flex className={styles.contentGroup}>
        <Image className={styles.icon} src={logoIcon} alt="logo" />

        <Flex className={styles.txtLinksGroup}>
          <Flex className={styles.txtLinkInnerGroup}>
            <TxtLinkGroup title="Navigation" links={navigationLinks} />
            <TxtLinkGroup title="News" links={newsLinks} />
          </Flex>
          <Flex className={styles.txtLinkInnerGroup}>
            <TxtLinkGroup title="FAQ" links={supportLinks} />
            <TxtLinkGroup title="Service Status" links={companyLinks} />
          </Flex>
        </Flex>

        <Flex className={styles.socialLinksGroup}>
          <Flex className={styles.socialLink}>
            <Image src={telegramIcon} alt="logo" />
            <Text className={styles.socialLinkText}>Join our Telegram</Text>
          </Flex>
          <Flex className={styles.socialLink}>
            <Image src={discordIcon} alt="logo" />
            <Text className={styles.socialLinkText}>Join our Discord</Text>
          </Flex>
          <Flex className={styles.socialLink}>
            <Image src={twitterIcon} alt="logo" />
            <Text className={styles.socialLinkText}>Follow us on Twitter</Text>
          </Flex>
        </Flex>
      </Flex>
      <Text className={styles.text} opacity={0.5}>
        Copyright © 2012- 2025 The Sandbox. All Rights Reserved
      </Text>
    </Flex>
  );
}

function TxtLinkGroup(props: {
  title?: string;
  links: { name: string; link: string }[];
}) {
  return (
    <Flex className={styles.txtLinksWrapper}>
      {props.title && <Text className={styles.title}>{props.title}</Text>}
      {props.links.map((link) => (
        <Flex key={link.name} className={styles.txtLink}>
          <Link to={link.link} color={"#FFFFFF80"}>
            {link.name}
          </Link>
        </Flex>
      ))}
    </Flex>
  );
}
